import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import Navigation from './common/Navigation/Navigation';
import { useEffect } from 'react';
import rem from './utils/rem/rem';

const AppContainer = styled.div`
  display: flex;
  height: 100vh;
  width: 100vw;
`;

const Main = styled.main`
  flex-grow: 1;
  overflow: auto;
  padding-bottom: ${rem(16)};
`;

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  // navigate from '/' to '/tables' dashboard page
  useEffect(() => {
    if (location.pathname === '/') navigate('/tables');
  }, [location.pathname]);

  return (
    <AppContainer>
      <Navigation />
      <Main>
        <Outlet />
      </Main>
    </AppContainer>
  );
}

export default App;
